import { render, staticRenderFns } from "./app.vue?vue&type=template&id=37c1d3b4&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=37c1d3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c1d3b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c1d3b4')) {
      api.createRecord('37c1d3b4', component.options)
    } else {
      api.reload('37c1d3b4', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=37c1d3b4&scoped=true&", function () {
      api.rerender('37c1d3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/product-finishes-slider/app.vue"
export default component.exports